import type { TourFrame } from '@carboncopyco/types';
import { useMemo } from 'react';

export const usePlayableSteps = (frames: TourFrame[]) =>
  useMemo(() => {
    if (frames?.length === 0) {
      return [];
    }
    return frames.flatMap((frame) => frame.steps);
  }, [frames]);
